import veevaVaultService from '../../services/veevaVaultService';
import {orderBy} from 'lodash';

const state = {
  connections: [],
  countries: [],
  initialized: false,
  languages: [],
  objects: [],
  products: [],
  websites: [],
}

const mutations = {
  setConnections(state, connections) {
    state.connections = connections;
  },
  setCountries(state, countries) {
    state.countries = countries;
  },
  setInitialized(state, initialized) {
    state.initialized = initialized;
  },
  setLanguages(state, languages) {
    state.languages = languages;
  },
  setObjects(state, objects) {
    state.objects = objects;
  },
  setProducts(state, products) {
    state.products = products;
  },
  setWebsites(state, websites) {
    state.websites = websites;
  }
}

/**
 * MLD-7910
 * @param error
 */
const handleError = (error) => {
  console.warn('Veeva Vault error: ', error);
}

const getters = {
  connections: state => state.connections,
  countries: state => state.countries,
  initialized: state => state.initialized,
  languages: state => state.languages,
  objects: state => state.objects,
  products: state => state.products,
  websites: state => state.websites,
}

const actions = {
  async initStore({commit, dispatch, getters}, force = false) {
    if (!getters.initialized || force) {
      return Promise.all([
        dispatch('fetchConnections'),
        dispatch('fetchVaultObjects', 'country__v').then(response => commit('setCountries', response.data.data)).catch(handleError),
        dispatch('fetchVaultObjects', 'language__sys').then(response => commit('setLanguages', response.data.data)).catch(handleError),
        dispatch('fetchObjects').catch(handleError),
        dispatch('fetchProducts').catch(handleError),
        //dispatch('fetchVaultObjects', 'website__v').then(response => commit('setWebsites', response.data.data)),*/
      ])
        .then(() => {
          commit('setInitialized', true);
        })
    }
    return Promise.resolve(true);
  },
  fetchConnections({commit}) {
    return axios.get(`/api/veeva/vault/connections`)
      .then(response => {
        commit('setConnections', orderBy(response.data, ['slug', 'name'], ['asc', 'asc']));
      })
      .catch(handleError);
  },
  fetchObjects({commit}) {
    return axios.get(`/api/veeva/vault/metadata/vobjects`)
      .then(response => {
        commit('setObjects', response.data.objects);
        return response.data.objects;
      });
  },
  fetchVaultObjects({commit}, objectName) {
    return veevaVaultService.retrieveVaultObjects(objectName);
  },
  async fetchProducts({commit}) {
    /*const params = {
      fields: 'id,name__v',
      sort: 'name__v asc',
    };*/
    const {data} = await veevaVaultService.retrieveProducts();
    commit('setProducts', data.data);
    return Promise.resolve(data.data);
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
}
